import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './VideoSidebar.css';

function VideoSidebar() {
  const navigate = useNavigate();
  const [latestVideo, setLatestVideo] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleVideosAnteriores = () => {
    navigate('/Video_principal');
  };

  // Cargar el video más reciente
  useEffect(() => {
    fetch(`${process.env.REACT_APP_VIDEO_PRINCIPAL_URL}/Videos_principales_get.php?limit=1`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          const video = data[0];
          setLatestVideo({
            id: video.ID,
            titulo: video.Titulo || 'Sin título',
            descripcion: video.Descripcion || '',
            videoUrl: video.video_url
          });
        }
      })
      .catch(err => console.error('Error cargando video sidebar:', err));
  }, []);

  const getViewerToken = () => {
    let token = localStorage.getItem('viewer_token');
    if (!token) {
      token = 'vt_' + Date.now() + '_' + Math.random().toString(36).substring(2, 12);
      localStorage.setItem('viewer_token', token);
    }
    return token;
  };

  const handleOpenModal = () => {
    if (latestVideo) {
      setIsModalOpen(true);
      fetch(`${process.env.REACT_APP_VIDEO_PRINCIPAL_URL}/registrar_visualizacion.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ video_id: latestVideo.id, token: getViewerToken() })
      }).catch(err => console.error('Error registrando visualizacion:', err));
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="video-sidebar-container">
      {/* Botón arriba del recuadro */}
      <button
        className="videos-anteriores-btn"
        onClick={handleVideosAnteriores}
      >
        Videos anteriores
      </button>

{/* Recuadro rectangular con video */}
      <div className="video-preview-wrapper">
        <div className="video-preview-box" onClick={handleOpenModal}>
        {latestVideo ? (
            <video
              className="video-preview-image"
              src={latestVideo.videoUrl}
              preload="auto"
              muted
              playsInline
              onLoadedMetadata={(e) => { e.target.currentTime = 2; }}
              onSeeked={(e) => { e.target.pause(); }}
            />
          ) : (
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/VIDEO_PRINCIPAL.jpg`}
              alt="Video preview"
              className="video-preview-image"
            />
          )}
          <div className="video-play-overlay">
            <div className="play-button-circle">
              <i className="fas fa-play"></i>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de reproducción */}
      {isModalOpen && latestVideo && (
        <div className="sidebar-modal-overlay" onClick={handleCloseModal}>
          <div className="sidebar-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="sidebar-modal-close-btn" onClick={handleCloseModal}>
              <i className="fas fa-times"></i>
            </button>
            <div className="sidebar-video-player-container">
              <video
                className="sidebar-video-player"
                controls
                autoPlay
                controlsList="nodownload"
              >
                <source src={latestVideo.videoUrl} type="video/mp4" />
                Tu navegador no soporta la reproducción de videos.
              </video>
            </div>
            <div className="sidebar-video-modal-info">
              <h2>{latestVideo.titulo}</h2>
              <p>{latestVideo.descripcion}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default VideoSidebar;